// AiAssistant.jsx
import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Button,
  Icon,
  List,
  Dropdown,
  Header,
  Image,
  Grid,
  Input,
  Segment,
  Checkbox,
} from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDatasets,
  getChatHistoryByFilter,
  getRadioDataActionSet,
  getUsersList,
  getChatHistory,
  ChatHistoryFilterSuccess,
} from "../../actions/dataConsoleAction";
import ChatDataSet from "./ChatDataSet";
import ChatBot from "./ChatBot";
import { useLocation, useNavigate } from "react-router-dom";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import Moment from "react-moment";
import "react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css";
import "../../styles/AiAssistant.css";
import moment from "moment";
import CustomToaster from "../../components/CustomToaster";
import AiLoader from "../../components/AiLoader";
import { getChatHistoryData, getRadioDataSets, getChatUsers } from '../../apis/index';
import { createQuickChatDataset } from '../../services/quickChatService';


const AiAssistant = ({
  filterPopUp,
  setFilterPopUp,
  onDataFromChild,
  onFilteredDataFromChild,
  resetFilterStartDate,
  isFilterPopUpClick,
  isClearFiltered,
  isChatHistoryCreated,
  onDatasetSelect,
  changeParams,
  handleClearFilter,
  isHandleViewCalled,
  isAssistantDataset,
  assistantParams, // New prop for AssistantSettings real-time data
  onUploadedFilesChange, // New prop for uploaded files change handler
  setActiveTab, // New prop for setting active tab
  chatViewPreference,
  onAgentActiveChange,
  onAgentRequestStatusChange,
  quitAgentFnRef,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { response } = useSelector(
      (state) => state.getlistDatasetReducer || { response: [] }
  );

  const { responseRadioDataList } = useSelector(
    (state) => state.listDatasetRadioReducer || {}
  );
  const { responseChatHistory } = useSelector(
    (state) => state.chatHistoryRed || {}

  );

  const { filterData, filterDataStatus } = useSelector(
    (state) => state.chatHistoryFilterData || {}
  );



  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const chatBotQueryParam = queryParams.get("c");
  const chatConversationParam = queryParams.get("cid");
  const quickChatParam = queryParams.get("quickChat");
  const methodParam = queryParams.get("method");
  const successParam = queryParams.get("success");
  const loadingParam = queryParams.get("loading");
  const [data, setData] = useState([]);
  const isMounted = useRef(true);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selection, setSelection] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedUserValues, setSelectedUserValues] = useState([]);
  const [isHandleSetDisabled, setIsHandleSetDisabled] = useState(false);
  const currentUserType = useSelector((state) => state.auth.user);
  const userToken = useSelector((state) => state.auth.token);
  const [selectedText, setSelectedText] = useState([]);
  const [selectedUserText, setSelectedUserText] = useState([]);
  const [selectedDatasetId, setSelectedDatasetId] = useState(null);
  const [toasterVisible, setToasterVisible] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [toasterAppearance, setToasterAppearance] = useState("error");
  const [shouldShowToaster, setShouldShowToaster] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleUploadedFilesChange = (files) => {
    console.log('AiAssistant: received uploaded files:', files);
    setUploadedFiles(files);
    if (onUploadedFilesChange) {
      console.log('AiAssistant: forwarding to parent');
      onUploadedFilesChange(files);
    }
  };
  const [shouldRenderChatBot, setShouldRenderChatBot] = useState(false);
  const [disableInputArea, setDisableInputArea] = useState(false);
  const [isQuickChatMode, setIsQuickChatMode] = useState(false);

  // State for users dropdown - fetched from chat/users endpoint
  const [chatUsers, setChatUsers] = useState([]);
  const [chatUsersLoading, setChatUsersLoading] = useState(false);

  // Fetch users from chat/users endpoint (for Admin/OrgAdmin filter UI)
  useEffect(() => {
    const fetchChatUsers = async () => {
      // Only fetch for Admin, OrgAdmin roles (HumanAgent has no filter UI)
      if (!currentUserType || (currentUserType !== "Admin" && currentUserType !== "OrgAdmin")) {
        return;
      }

      try {
        setChatUsersLoading(true);
        const response = await getChatUsers();
        if (response?.data?.success && response.data.data) {
          setChatUsers(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching chat users:', error);
      } finally {
        setChatUsersLoading(false);
      }
    };

    fetchChatUsers();
  }, [currentUserType]);

  const getDataSet = () => {
    try {
      dispatch(getDatasets());
    } catch (error) {
      console.error("Error in getting DataSet:", error);
    }
  };

  const getRadioDataSet = () => {
    try {
      dispatch(getRadioDataActionSet());
    } catch (error) {
      console.error("Error in getting DataSet:", error);
    }
  };

  const handleDatasetSelect = (datasetId) => {
    setSelectedDatasetId(datasetId);

    // If you need to pass the datasetId up to the parent component, call the prop function
    if (onDatasetSelect) {
      onDatasetSelect(datasetId);
    }
  };

  useEffect(() => {
    if (response.length > 0) {
      setData(response);
    }

    if (filterPopUp) {
      dispatch(ChatHistoryFilterSuccess([]));
      setOpenPopUp(true);
    }

    if (isMounted.current) {
      currentUserType && currentUserType === "User"
        ? getRadioDataSet()
        : getDataSet();
      isMounted.current = false;
    }

    if (resetFilterStartDate) {
      if (
        resetFilterStartDate.hasOwnProperty("startDate") &&
        resetFilterStartDate.startDate == null
      ) {
        setStartDate(resetFilterStartDate.startDate);
        handleFilterData("start_date");
      }

      if (
        resetFilterStartDate.hasOwnProperty("endDate") &&
        resetFilterStartDate.endDate == null
      ) {
        setEndDate(resetFilterStartDate.endDate);
        handleFilterData("end_date");
      }

      if (
        resetFilterStartDate.hasOwnProperty("datasets") &&
        resetFilterStartDate.datasets == null
      ) {
        setSelectedValues(resetFilterStartDate.datasets);
        handleFilterData("datasets");
      }

      if (
        resetFilterStartDate.hasOwnProperty("users") &&
        resetFilterStartDate.users == null
      ) {
        setSelectedUserValues(resetFilterStartDate.users);
        handleFilterData("users");
      }


      setIsHandleSetDisabled(true);
    }
  }, [
    dispatch,
    response,
    filterPopUp,
    resetFilterStartDate,
    currentUserType,
    userToken,
  ]);

  useEffect(() => {
      const newStartDate = new Date(startDate);
      const newEndDate = new Date(endDate);
      onFilteredDataFromChild({
        startDate: startDate ? moment(newStartDate).format("MM/DD/YYYY") : "",
        endDate: endDate ? moment(newEndDate).format("MM/DD/YYYY") : "",
        datasets: selectedValues,
        users: selectedUserValues,
        filter: true,
        datasetNames: selectedText,
        userNames: selectedUserText,
      });
  },  [startDate, endDate, selectedValues, selectedUserValues]);


  useEffect(() => {
    if (filterData && filterDataStatus === 200) {
      onDataFromChild(filterData);
    }
  },  [filterData, filterDataStatus]);

  useEffect(() => {
    if (isClearFiltered) {
      sortHandleCloseOnCancel();
    }
  }, [isClearFiltered]);

  const toggleSelection = (e, { label, checked }) => {
    if (checked) {
      setSelection([...selection, label]);
    } else {
      setSelection(selection.filter((el) => el !== label));
    }
  };

  const onChangeStartDate = (event, data) => {
    const newDateValue = data.value ? new Date(data.value) : "";
    setStartDate(newDateValue);
    if (newDateValue || endDate || selectedValues.length > 0 || selectedUserValues.length > 0) {
      setIsHandleSetDisabled(true);
    } else {
      setIsHandleSetDisabled(false);
    }
  };
  const onChangeEndDate = (event, data) => {
    const endDateValue = data.value ? new Date(data.value) : "";
    setEndDate(endDateValue);
    if (endDateValue || startDate || selectedValues.length > 0 || selectedUserValues.length > 0) {
      setIsHandleSetDisabled(true);
    } else {
      setIsHandleSetDisabled(false);
    }
  };

  const checkAddButtonDisabled = () => {
    // Enable Apply when at least one filter is set (any date, dataset, or user)
    if (!startDate && !endDate && selectedValues.length == 0 && selectedUserValues.length == 0) {
      setIsHandleSetDisabled(false);
    } else {
      setIsHandleSetDisabled(true);
    }
  };

  const handleActionChange = (_, { value }) => {
    setSelectedAction(value);
    checkAddButtonDisabled();
  };

  const clearFilter = () => {
    setIsHandleSetDisabled(false);
    setStartDate("");
    setEndDate("");
    setSelectedAction("");
    setSelectedValues([]);
    setSelectedUserValues([]);
    setSelectedText([]);
    setSelectedUserText([]);
  };

  const sortHandleClose = () => {
    console.log("check status");
    setOpenPopUp(false);
    setFilterPopUp(false);
  };

  const sortHandleCloseOnCancel = () => {
    setStartDate("");
    setEndDate("");
    setSelectedAction("");
    setSelectedValues([]);
    setSelectedUserValues([]);
    setSelectedText([]);
    setSelectedUserText([]);
    setOpenPopUp(false);
    setFilterPopUp(false);
    setIsHandleSetDisabled(false);
  };

  const handleDropdownChange = (event, { value }) => {
    const selectedOptions = Array.isArray(value) ? value : [value];

    // Find the option objects in datasetOptions that match the selected values
    const selectedTexts = datasetOptions
      .filter((option) => selectedOptions.includes(option.value))
      .map((option) => option.text);

    // 'selectedTexts' now contains the text of the selected option(s)
    // Use 'selectedTexts' as needed in your application
    setSelectedValues(value);
    setSelectedText(selectedTexts);
    value.length > 0 || startDate || endDate
      ? setIsHandleSetDisabled(true)
      : setIsHandleSetDisabled(false);
  };

  const handleUserDropdownChange = (event, { value }) => {
    const selectedUserOptions = Array.isArray(value) ? value : [value];

    // Find the option objects in datasetOptions that match the selected values
    const selectedUserText = userOptions
      .filter((option) => selectedUserOptions.includes(option.value))
      .map((option) => option.text);

    // 'selectedTexts' now contains the text of the selected option(s)
    // Use 'selectedTexts' as needed in your application
    setSelectedUserValues(value);
    setSelectedUserText(selectedUserText);
    value.length > 0 || startDate || endDate
      ? setIsHandleSetDisabled(true)
      : setIsHandleSetDisabled(false);
  };

  // Custom render label for dropdown to use SVG icon instead of font icon
  const renderDropdownLabel = (label, index, defaultLabelProps) => ({
    content: label.text,
    removeIcon: <img src="/images/grey-close.svg" alt="remove" className="dropdown-remove-icon" />,
    ...defaultLabelProps,
  });

  const actions = [
    { key: "s", text: "Select", value: "" },
    { key: "a", text: "A to Z", value: "asc" },
    { key: "z", text: "Z to A", value: "desc" },
  ];

  let datasetOptions = [];
  if (currentUserType && currentUserType === "User") {
    if (responseRadioDataList && responseRadioDataList.length > 0) {
      datasetOptions = responseRadioDataList.map((dataset) => {
        return { text: dataset.datasetName, value: dataset.id };
      });
    }
  } else {
    if (response && response.length > 0) {
      datasetOptions = response.map((dataset) => {
        return { text: dataset.datasetName, value: dataset.id };
      });
    }
  }

  // Build userOptions from chatUsers (fetched from /chat/users endpoint)
  let userOptions = [];
  if (currentUserType && (currentUserType === "Admin" || currentUserType === "OrgAdmin")) {
    if (chatUsers && chatUsers.length > 0) {
      userOptions = chatUsers.map((user) => ({
        text: user.username,
        value: user.id,
      }));
    }
  }
  

  const handleClose = () => {
    setOpenPopUp(false);
    setFilterPopUp(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleFilterData = async (start_date = "") => {
    // Chip-removal calls (start_date is "start_date" / "end_date" / "datasets" / "users")
    // must always re-fetch even if isHandleSetDisabled is currently false.
    const isChipRemoval = start_date !== "";
    if (isHandleSetDisabled || isChipRemoval) {
      const newStartDate = startDate ? new Date(startDate).toISOString() : "";
      const newEndDate = endDate ? new Date(endDate).toISOString() : "";
      let fromDate =
        startDate && start_date !== "start_date" ? newStartDate : "";
      let toDate = endDate && start_date !== "end_date" ? newEndDate : "";
      let datasetIds =
        selectedValues && selectedValues.length > 0 && start_date !== "datasets"
          ? selectedValues.join(",")
          : "";
      let userIds =
        selectedUserValues && selectedUserValues.length > 0 && start_date !== "users"
            ? selectedUserValues.join(",")
            : "";
      let sort = selectedAction || "";

      let formatedFromDate = formatDate(fromDate);
      if (isNaN(new Date(formatedFromDate))) {
        formatedFromDate = "";
      }

      let formatedToDate = formatDate(toDate);
      if (isNaN(new Date(formatedToDate))) {
        formatedToDate = "";
      }

      // If only fromDate is provided (no toDate), default toDate to today
      if (formatedFromDate && !formatedToDate) {
        formatedToDate = formatDate(new Date());
      }
      let queryString = `?fromDate=${formatedFromDate}&toDate=${formatedToDate}&datasetIds=${datasetIds}&userIds=${userIds}${sort ? `&sort=${sort}` : ""}`;

      dispatch(getChatHistoryByFilter(queryString));
      sortHandleClose();
      isFilterPopUpClick(true);
      handleClearFilter();
      setFilterPopUp(false);
    }
  };
  const today = new Date();

  const checkChatHistoryCreated = (flag) => {
    isChatHistoryCreated(flag);
  };

  const fetchRadioData = async () => {
    try {
      const response = await getRadioDataSets();
      if (Array.isArray(response.data)) {
        const ids = response.data.map(item => item.id);
        return ids;
      } else {
        console.error('Unexpected response format:', response);
        return [];
      }
    } catch (error) {
      console.error('Error fetching radio data:', error);
      return [];
    }
  };

  const fetchChatHistoryData = async () => {
    try {
      const response = await getChatHistoryData();
      console.log('response chat history:', response);
      const chats = Array.isArray(response.data)
        ? response.data
        : (response.data?.data || []);
      if (Array.isArray(chats)) {
        const chatMetaIds = chats.map(item => item.id);
        return chatMetaIds;
      } else {
        console.error('Unexpected response format:', response);
        return [];
      }
    } catch (error) {
      console.error('Error fetching chat history data:', error);
      return [];
    }
  };

  
  const isChatBotQueryParamInResponse = async (chatBotQueryParam) => {
    if (responseRadioDataList && responseRadioDataList.length > 0) {
      return responseRadioDataList.some(dataset => dataset.id === chatBotQueryParam);
    } else {
      const fetchedIds = await fetchRadioData();
      return fetchedIds.includes(chatBotQueryParam);
    }
  };

  const isChatBotQueryParamInChatHistory = async (chatConversationParam) => {
    if (responseChatHistory && responseChatHistory.length > 0) {
      return responseChatHistory.some(chat => chat.id === chatConversationParam);
    } else {
      const fetchedHistory = await fetchChatHistoryData();
      return fetchedHistory.includes(chatConversationParam);
    }
  };

  useEffect(() => {
    const checkChatBotQueryParam = async () => {
      if (chatBotQueryParam) {
        // Check for quick chat mode first, before doing dataset access validation
        const isQuickChat = quickChatParam === "1" && (methodParam === "quickChat" || methodParam === "assistantQuickChat");
        
        if (isQuickChat) {
          console.log('Quick chat mode: bypassing dataset access check');
          setDisableInputArea(false);
          setShouldRenderChatBot(true);
          return;
        }
        
        const isInResponse = await isChatBotQueryParamInResponse(chatBotQueryParam);
        if (!isInResponse && currentUserType != "ExternalUser" && currentUserType != "HumanAgent") {
          if (chatConversationParam) {
            const isInChatHistory = await isChatBotQueryParamInChatHistory(chatConversationParam);
            if (isInChatHistory) {
              setDisableInputArea(true);
              setShouldRenderChatBot(true);
              setShouldShowToaster(true);
              console.log('Chat history exists');
            } else {
              handleDatasetNotAvailable();
            }
          } else {
            handleDatasetNotAvailable();
          }
        } else {
          console.log('Dataset exists');
          setDisableInputArea(false);
          setShouldRenderChatBot(true);
        }
      }
    };

    checkChatBotQueryParam();
  }, [chatBotQueryParam, chatConversationParam, quickChatParam, methodParam]);

  useEffect(() => {
    if (quickChatParam === "1" && (methodParam === "quickChat" || methodParam === "assistantQuickChat")) {
      setIsQuickChatMode(true);
      console.log(`Quick Chat mode detected: ${methodParam}`);
    } else {
      setIsQuickChatMode(false);
    }
  }, [quickChatParam, methodParam]);

  // Auto-create quick chat dataset when loading parameter is present (for direct navigation)
  useEffect(() => {
    const autoCreateQuickChat = async () => {
      if (loadingParam === "true" && quickChatParam === "1" && methodParam === "quickChat" && !chatBotQueryParam) {
        console.log('Auto-creating quick chat dataset');
        try {
          const { datasetId, datasetName } = await createQuickChatDataset('quickChat');
          navigate(`/aiassistant?c=${datasetId}&quickChat=1&method=quickChat&title=${datasetName}&success=quickChat`);
        } catch (error) {
          console.error('Error creating quick chat:', error);
          showToaster('Failed to create Quick Chat. Please try again.', 'error');
          navigate('/aiassistant');
        }
      }
    };
    autoCreateQuickChat();
  }, [loadingParam, quickChatParam, methodParam, chatBotQueryParam]);

  useEffect(() => {
    if (successParam) {
      if (successParam === "quickChat") {
        showToaster("Quick Chat created successfully!", "success");
      } else if (successParam === "assistantQuickChat") {
        showToaster("Assistant Quick Chat created successfully!", "success");
      }
      
      // Remove the success parameter from URL to prevent showing toast on refresh
      const newUrl = new URL(window.location);
      newUrl.searchParams.delete("success");
      window.history.replaceState({}, document.title, newUrl.toString());
    }
  }, [successParam]);

  const handleDatasetNotAvailable = () => {
    navigate("/aiassistant");
    setShouldShowToaster(true);
  };

  useEffect(() => {
    if (shouldShowToaster) {
        showToaster("You don't have access to dataset or dataset is deleted", "error");
        setShouldShowToaster(false); // Reset the flag
    }
  }, [shouldShowToaster]);

  const showToaster = (message, appearance) => {
    setToasterVisible(true);
    setToasterMessage(message);
    setToasterAppearance(appearance); 
    console.log("toasterMessage", appearance);
  };


  const closeToaster = () => {
    setToasterVisible(false);
  };

  return (
    <div className="ai-assistant">
      {toasterVisible && (
        <CustomToaster
          message={toasterMessage}
          duration={2000}
          onClose={closeToaster}
          position="right-top"
          appearance={toasterAppearance}
        />
      )}
      <div className="ai-chat-box">
        {loadingParam === "true" && quickChatParam === "1" && methodParam === "quickChat" ? (
          <div className="quick-chat-loading-container">
            <AiLoader />
            <div className="loading-text">Creating Quick Chat...</div>
          </div>
        ) : chatBotQueryParam || chatConversationParam ? (
          shouldRenderChatBot ? (
            <ChatBot
              checkChatHistoryCreated={checkChatHistoryCreated}
              changeParams={changeParams}
              disableInputArea={disableInputArea}
              isHandleViewCalled={isHandleViewCalled}
              isAssistantDataset={isAssistantDataset}
              assistantParams={assistantParams} // Pass real-time AssistantSettings data
              onUploadedFilesChange={handleUploadedFilesChange}
              setActiveTab={setActiveTab}
              chatViewPreference={chatViewPreference}
              onAgentActiveChange={onAgentActiveChange}
              onAgentRequestStatusChange={onAgentRequestStatusChange}
              quitAgentFnRef={quitAgentFnRef}
            />
          ) : null
        ) : (
          <>
            <ChatDataSet
            onDatasetSelect={handleDatasetSelect} />
          </>
        )}
      </div>
      <Modal
        open={openPopUp}
        onClose={handleClose}
        size="tiny"
        className="add-document-model filterPopup"
      >
        <Modal.Content>
          <Header as="h3">
            Filter and sort by
            <span
              style={{ color: "red", fontSize: "12px", cursor: "pointer" }}
              onClick={clearFilter}
              data-cy="clear-filter-click-cy"
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Clear all
            </span>
          </Header>
          <Header as="h5">Date</Header>
          <div className="filterDate">
            <div className="dateFromOuter" data-cy="startdate-dropdown-cy">
              <SemanticDatepicker
                className="field dateFrom"
                format="MM/DD/YYYY"
                value={startDate}
                onChange={onChangeStartDate}
                isClearable={false}
                calendarIcon={
                  <img
                    src="/images/search.svg"
                    alt="Logo"
                    style={{ cursor: "pointer" }}
                  />
                }
                maxDate={endDate ? endDate : today}
                inputProps={{ style: { cursor: "pointer" } }}
              />{" "}
            </div>
            <div className="filterTo">To </div>
            <div className="dateFromOuter" data-cy="enddate-dropdown-cy">
              <SemanticDatepicker
                format="MM/DD/YYYY"
                value={endDate}
                onChange={onChangeEndDate}
                className="field dateTo"
                isClearable={false}
                calendarIcon={
                  <img
                    src="/images/search.svg"
                    alt="Logo"
                    style={{ cursor: "pointer" }}
                  />
                }
                minDate={startDate}
                maxDate={today}
                inputProps={{ style: { cursor: "pointer" } }}
              />
            </div>
          </div>
          <Header as="h5">Sort by</Header>
          <Dropdown
            placeholder="Select"
            options={actions}
            selection
            onChange={handleActionChange}
            value={selectedAction}
            style={{ marginBottom: "10px", width: "100%" }}
            calendarIcon={<img src="/images/search.svg" alt="Logo" />}
            data-cy="sort-dropdown-cy"
          />
          <Header as="h5">Dataset</Header>
          <Dropdown
            placeholder="Select"
            multiple
            search
            selection
            options={datasetOptions}
            onChange={handleDropdownChange}
            value={selectedValues}
            renderLabel={renderDropdownLabel}
            style={{ marginBottom: "10px", width: "100%", cursor: "pointer" }}
            data-cy="dataset-dropdown-cy"
          />

<Header as="h5">User</Header>
          <Dropdown
            placeholder={chatUsersLoading ? "Loading users..." : "Select"}
            multiple
            search
            selection
            loading={chatUsersLoading}
            disabled={chatUsersLoading}
            options={userOptions}
            onChange={handleUserDropdownChange}
            value={selectedUserValues}
            renderLabel={renderDropdownLabel}
            style={{ marginBottom: "10px", width: "100%", cursor: "pointer" }}
            data-cy="user-dropdown-cy"
          />
      

        </Modal.Content>

        
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={sortHandleClose}
            data-cy="cancel-filter-btn-cy"
          >
            Cancel
          </button>
          <button
            disabled={!isHandleSetDisabled}
            className="add-btn"
            onClick={handleFilterData}
            data-cy="apply-filter-btn-cy"
          >
            Apply
          </button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default AiAssistant;
